import commonEn from "@/core/common/internationalization/dictionaries/common-en";
import domainEn from "@/core/common/internationalization/dictionaries/domain-en";
import navigationEn from "@/core/common/internationalization/dictionaries/navigation-en";

export default {
  common: commonEn,
  navigation: navigationEn,
  domain: domainEn,
};
